import ReactDOMServer from 'react-dom/server';
import React, { FunctionComponent, SVGProps } from 'react';

export const UseSvgDataUri = (svgComponent: FunctionComponent<SVGProps<SVGSVGElement>>, fillColor?: string) => {
    let svgString = ReactDOMServer.renderToStaticMarkup(React.createElement(svgComponent));
    if (fillColor) svgString = svgString.replaceAll('<svg', `<svg fill="${fillColor}"`);

    return 'data:image/svg+xml,' + encodeURIComponent(svgString);
};
